import src from '../assets/greensidegolfclub-dark.png';
import { imageLogo } from './imageLogo';

export const GreensideGolfClubDarkLogo = imageLogo({
  src,
  width: 800,
  height: 251,
  alt: 'Greenside Golf Club',
});
